const mutations = {
	SET_USER(state, payload) {
		state.user = payload;
	},
	SET_LOGO(state, payload) {
		state.logo = payload;
	},
	SET_NAME(state, payload) {
		state.name = payload;
	},
	SET_DOMAIN(state, payload) {
		state.domain = payload;
	},
	SET_IS_LICENSED(state, payload) {
		state.isLicensed = payload;
	},
	SET_ACCOUNT_MANAGER(state, payload) {
		state.accountManagerUrl = payload;
	},
	SET_LOADED_APPS(state, payload) {
		state.loadedApps = payload;
	},
	SET_LOADED_POLICIES(state, payload) {
		state.loadedPolicies = payload;
	},
	SET_LOADED_CASES(state, payload) {
		state.loadedCases = payload;
	},
	SET_PARTNER(state, payload) {
		state.partner = payload;
	},
	SET_LICENSE_PLANS(state, payload) {
		state.licensePlans = payload;
	},
	SET_PAGE_SIZE(state, payload) {
		state.pageSize = payload;
	},
	SET_TOTAL_ROWS_LICENSE(state, payload) {
		state.totalRowsLicense = payload;
	},
	SET_LOADED_COLLABORATORS(state, payload) {
		state.loadedCollaborators = payload;
	},
	UPDATE_SUBSCRIPTION(state, payload) {
		delete payload.subscription.app;
		delete payload.subscription.subscriptions;
		state.loadedCases.find(app => app.id === payload.app_id).subscription = payload.subscription;
	},
	UPDATE_TOTAL_LICENSE(state, { newPlan, prevPlan }) {
		if (state.partner.total_license[newPlan] !== undefined) {
			state.partner.total_license[newPlan] += 1;
		}
		if (state.partner.total_license[prevPlan] !== undefined) {
			state.partner.total_license[prevPlan] -= 1;
		}
	}
};

export default mutations;
